export default __webpack_public_path__ + "static/contact_bg_map-409b6ec076fa291f6e1596147ec97e11.png";